import { computed, observable } from 'mobx';
import { IInvoiceServiceItemBlockStyles } from '~/types/block-styles.types';
import { IInvoiceServiceItemBlockResponse } from '~/types/server.types';
import { ServiceItemBlock } from '~/models/blocks/service-item-block.model';
import type { InvoiceBlock } from '~/models/blocks/invoice-block.model';
import { TBlock } from '~/types/builder.types';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { RootStore } from '~/stores/root.store';

type InvoiceServiceItemBlockDataForServer = ReturnType<
    ServiceItemBlock['getDataForServer']
> &
    Pick<
        IInvoiceServiceItemBlockResponse,
        'type' | 'service_item' | 'service_type' | 'service_image'
    >;

export class InvoiceServiceItemBlock extends ServiceItemBlock {
    type: 'invoice_service_item_block';
    @observable styles: IInvoiceServiceItemBlockStyles;

    constructor(
        block: IInvoiceServiceItemBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    get isDeletable() {
        return true;
    }

    @computed
    get label() {
        return this.isInPackage ? 'Service sub-item' : 'Service item';
    }

    @computed
    get shouldExpandOnSelect() {
        return false;
    }

    @computed
    get invoiceBlock(): InvoiceBlock {
        let { parent } = this;

        while (parent && parent.type !== 'invoice_container_block') {
            parent = parent.parent;
        }

        return parent as InvoiceBlock;
    }

    getDataForServer(): InvoiceServiceItemBlockDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'invoice_service_item_block',
            service_item: { ...this.service_item },
            service_type: this.service_type,
            service_image: { ...this.service_image }
        };
    }

    canBeParentOf(block: TBlock) {
        return (
            this.isPackage &&
            block instanceof InvoiceServiceItemBlock &&
            !block.isPackage
        );
    }
}
